<template>
    <div class="info-text">
        <SrTooltip :left="left" :right="isRight" :top="top" :bottom="bottom">
            <template #activator="{ on }">
                <span class="info-icon" v-on="on"> i </span>
            </template>
            <SrBodyText class="info-content brand-blue--text">
                <slot />
            </SrBodyText>
        </SrTooltip>
    </div>
</template>

<script>
import SrTooltip from '../SrTooltip/SrTooltip';
import SrBodyText from '../SrBodyText/SrBodyText';

export default {
    name: 'SrInfoBox',
    components: {
        SrBodyText,
        SrTooltip,
    },
    props: {
        left: {
            type: Boolean,
            default: false,
        },
        right: {
            type: Boolean,
            default: false,
        },
        top: {
            type: Boolean,
            default: false,
        },
        bottom: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        allDirections() {
            return [this.left, this.right, this.top, this.bottom];
        },
        isRight() {
            if (this.allDirections.every((direction) => direction === false)) {
                return true;
            }
            return this.right;
        },
    },
};
</script>
